<template>
  <div class="analytic-report">
    <template v-if="cameraInfo && cameraInfo.isAvailableArchive()">
      <!-- Заголовок камеры -->


      <!-- Настройки отчета -->
      <div class="analytic-report__settings">
        <div v-if="this.$route.params.cameraNumber" class="report-header">
          <CamsButton
            icon-type="only"
            type="button"
            class="button-back"
            @click="goBack()"
          >
            <svg class="icon">
              <use xlink:href="#icon-arrow-right" />
            </svg>
          </CamsButton>
          <div class="report-header__meta">
            <div class="report-header__title">
              {{ $t('cameraLabel', {number: cameraInfo.number}) }}
            </div>
            <div class="report-header__subtitle">
              {{ cameraInfo.title }}
            </div>
          </div>
        </div>
        <SmartSelect
          v-model="timeBucket"
          :options="settingsTimeBucket"
          :caption="$t('reportType')"
          width="fill"
          class="analytic-report__settings-control analytic-report__settings-control_small"
          @input="loadReportTimeBucket"
        />
        <SmartInputDate
          ref="archiveFromInput"
          v-model="archiveFrom"
          :config-flat-pickr="{ maxDate: new Date()}"
          :caption="$t('startDate')"
          :locale="this.locale"
          class="analytic-report__settings-control analytic-report__settings-control_small"
        />
        <SmartInputDate
          ref="archiveToInput"
          v-model="archiveTo"
          :config-flat-pickr="{maxDate: new Date()}"
          :caption="$t('endDate')"
          :locale="this.locale"
          class="analytic-report__settings-control analytic-report__settings-control_small"
          :error="archiveToError"
        />
        <CamsButton
          type="button"
          class="analytic-report__settings-control"
          @click="openDialogAddCamera()"
        >
          {{ $t('addCamera', {count: this.selectedCameraNumbers.length || 1}) }}
        </CamsButton>
        <CamsButton
          class="analytic-report__settings-control"
          priority="primary"
          type="button"
          @click="downloadTableAsCSVReport()"
        >
          {{ $t('downloadReport') }}
        </CamsButton>
        <div class="analytic-report__view-container">
          <span class="analytic-report__view-label">{{ $t('viewLabel') }}</span>
          <!-- Переключатель вида отчета -->
          <div class="analytic-report__view-toggle">
            <CamsButton
              :class="{'analytic-report__view-button--active': viewType === 'table'}"
              class="analytic-report__view-button"
              priority="secondary"
              type="button"
              icon-type="only"
              @click="viewType = 'table'"
            >
              <svg class="analytic-report__view-icon">
                <use xlink:href="#icon-table-view" />
              </svg>
            </CamsButton>
            <CamsButton
              :class="{'analytic-report__view-button--active': viewType === 'chart'}"
              class="analytic-report__view-button"
              priority="secondary"
              type="button"
              icon-type="only"
              @click="viewType = 'chart'"
            >
              <svg class="analytic-report__view-icon">
                <use xlink:href="#icon-chart-view" />
              </svg>
            </CamsButton>
          </div>
        </div>
      </div>
      <SpinnerLoading v-if="isLoading || !isInitialDataLoaded && !archiveToError" class="loader_center" color="blue" />
      <div v-if="apiError" class="analytic-report__no-data">
        <span style="color: #ff4d4f;">{{ apiError }}</span>
      </div>
      <div v-else-if="!isLoading && isInitialDataLoaded && !hasChartData" class="analytic-report__no-data">
        {{ $t('noData') }}
      </div>
      <!-- График -->
      <div v-if="viewType === 'chart' && !isLoading && hasChartData && isInitialDataLoaded" class="people-report-chart">
        <div class="people-report-chart__summary">
          <div class="summary-card summary-card_in">
            <div class="summary-card__value">
              {{ $t('enteredCount', {count: totalIn}) }}
            </div>
          </div>
          <div class="summary-card summary-card_out">
            <div class="summary-card__value">
              {{ $t('exitedCount', {count: totalOut}) }}
            </div>
          </div>
        </div>
        <div class="people-report-chart__canvas">
          <apexchart
            type="bar"
            height="100%"
            :options="chartOptions"
            :series="chartSeries"
          />
        </div>
      </div>
      <!-- Пагинация (только для таблицы) -->
      <div v-if="viewType === 'table' && hasChartData && !isLoading" class="analytic-report__pagination">
        <paginate
          v-model="currentPage"
          class="analytic-report__pagination_smart-pagination"
          :page-count="allPages"
          :page-range="5"
          active-class="smart-pagination__page_active"
          break-view-class="smart-pagination__page_collapse"
          container-class="smart-pagination"
          next-class="smart-pagination__page smart-pagination__next-prev"
          next-link-class="smart-pagination__page-link small"
          next-text="<svg class='icon icon-arrow-left'><use xlink:href='#icon-arrow-left'></use></svg>"
          page-class="smart-pagination__page"
          page-link-class="smart-pagination__page-link small"
          prev-class="smart-pagination__page smart-pagination__next-prev"
          prev-link-class="smart-pagination__page-link small"
          prev-text="<svg class='icon icon-arrow-right'><use xlink:href='#icon-arrow-right'></use></svg>"
        />
        <SmartSelect
          v-model="pageSize"
          :options="optionsPageSize"
          :caption="$t('itemsPerPage')"
          width="fill"
          class="analytic-report__pagination_smart-select-pagination"
          size="s"
          @input="setPageSize(pageSize)"
        />
      </div>
      <!-- Таблица -->
      <!-- Таблица только для агрегированных отчётов -->
      <table v-if="viewType === 'table' && hasChartData && !isLoading" class="cams-table">
        <tr>
          <th class="cams-table__cell cams-table__cell_fixed-width" />
          <th class="cams-table__cell" style="width: 400px">
            {{ $t('date') }}
          </th>
          <th class="cams-table__cell">
            {{ $t('inCount') }}
          </th>
          <th class="cams-table__cell">
            {{ $t('outCount') }}
          </th>
        </tr>
        <tr v-for="(message, index) in paginatedBucketResults" :key="message.id || index" :class="{'warning warning-bg': message.alarm}">
          <td class="cams-table__cell cams-table__cell_fixed-width" />
          <td class="cams-table__cell">
            {{ message.start | localDateTime }} - {{ message.end | localDateTime }}
          </td>
          <td class="cams-table__cell">
            {{ message.in_count }}
          </td>
          <td class="cams-table__cell">
            {{ message.out_count }}
          </td>
        </tr>
      </table>
    </template>
    <template v-else>
      <p>{{ $t('archiveError') }}</p>
    </template>
    <iframe :src="downloadUrl" frameborder="0" height="1" width="1" />
  </div>
</template>

<script>
import {analyticReportMixin} from "@/components/oneScreen/reports/mixins.js";
import {downloadCSV} from "@/utils/helpers.js";
import {
  BASE_CHART_OPTIONS,
  ACTION_LOAD_PEOPLE_COUNT_REPORT,
  ACTION_LOAD_PEOPLE_COUNT_REPORT_COUNT_BUCKET,
} from "@/store/analytics/peopleCount/index.js";
import VueApexCharts from "vue-apexcharts";
import AddCameraToReportDialog from "@/components/pacs/analytics/peopleCounter/AddCameraToReportDialog.vue";
import {ROUTE_PACS_PEOPLE_COUNT_ANALYTICS} from "@/router/names.js";

/**
 * Отчет по подсчету посетителей.
 * Компонент отображает статистику входа/выхода людей в различных форматах:
 * - График (столбчатая диаграмма)
 * - Таблица (с пагинацией)
 * Поддерживает различные периоды агрегации данных: почасовой, ежедневный, еженедельный, ежемесячный.
 */
export default {
  name: "PeopleReportScreen",
  mixins: [
    analyticReportMixin,
  ],
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    const archiveTo = new Date();
    const archiveFrom = new Date();
    archiveFrom.setMonth(archiveFrom.getMonth() - 1);
    return {
      archiveFrom,
      archiveTo,
      searchText: null,
      timeBucket: "day",
      settingsTimeBucket: null,
      calendarOpen: null,
      viewType: "chart",
      allBucketResults: [],
      allDefaultReportData: [],
      selectedCameraNumbers: [],
      selectAllByFilter: false,
      camerasFilter: null,
      isInitialDataLoaded: false,
      apiError: null,
    };
  },
  computed: {
    archiveToError() {
      if (!this.archiveTo) {
        return this.$t('enterDate');
      }
      const toDate = new Date(this.archiveTo);
      if (isNaN(toDate.getTime()) || toDate > new Date()) {
        return this.$t('invalidDate');
      }
      return "";
    },
    hasChartData() {
      return this.allBucketResults && this.allBucketResults.length > 0;
    },
    chartOptions() {
      return {
        ...BASE_CHART_OPTIONS,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: this.getColumnWidth(),
            borderRadius: 2,
          },
        },
        xaxis: {
          ...BASE_CHART_OPTIONS.xaxis,
          categories: this.chartCategories,
          labels: {
            ...BASE_CHART_OPTIONS.xaxis.labels,
            formatter: this.formatXAxisLabel,
          },
        },
        yaxis: {
          title: {
            text: this.$t('peopleCount')
          }
        },
      };
    },
    paginatedBucketResults() {
      if (!this.allBucketResults.length) return [];
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.allBucketResults.slice(startIndex, endIndex);
    },

    bucketPagesCount() {
      if (!this.allBucketResults.length) return 1;
      return Math.ceil(this.allBucketResults.length / this.pageSize);
    },
    chartDataForGraph() {
      if (!this.hasChartData) return [];
      return [...this.allBucketResults];
    },
    chartCategories() {
      if (!this.hasChartData) return [];
      return this.chartDataForGraph.map(m =>
        this.formatChartLabel(m.start, m.end)
      );
    },
    chartSeries() {
      if (!this.hasChartData) return [];

      return [
        {
          name: this.$t("entrance"),
          data: this.chartDataForGraph.map(m => m.in_count),
        },
        {
          name: this.$t("exit"),
          data: this.chartDataForGraph.map(m => m.out_count),
        },
      ];
    },

    totalIn() {
      if (!this.hasChartData) return 0;
      return this.allBucketResults.reduce((sum, m) => sum + m.in_count, 0);
    },

    totalOut() {
      if (!this.hasChartData) return 0;
      return this.allBucketResults.reduce((sum, m) => sum + m.out_count, 0);
    },
    clearArchiveFrom() {
      return this.archiveFrom && this.archiveTo
        ? new Date(Math.min(this.archiveFrom.getTime(), this.archiveTo.getTime()))
        : null;
    },

    clearArchiveTo() {
      return this.archiveFrom && this.archiveTo
        ? new Date(Math.max(this.archiveFrom.getTime(), this.archiveTo.getTime()))
        : null;
    },
  },
  watch: {
    archiveFrom(newStart) {
      if (newStart && this.archiveTo && this.archiveTo < newStart) {
        this.archiveTo = newStart;
      }
      this.isInitialDataLoaded = false;
      this.debouncedLoadReportBucket();
    },
    archiveTo(newEnd) {
      if (newEnd && this.archiveFrom && newEnd < this.archiveFrom) {
        this.archiveTo = this.archiveFrom;
      }
      this.isInitialDataLoaded = false;
      this.debouncedLoadReportBucket();
    },
    timeBucket() {
      this.isInitialDataLoaded = false;
    },
    searchText() {
      this.isInitialDataLoaded = false;
      this.debouncedLoadReportBucket();
    },
  },

  created() {
    this.debouncedLoadReportBucket = _.debounce(this.loadReportTimeBucket, 350);
    this.getTimePeriondsForSelect();
    if (this.cameraInfo && this.cameraInfo.isAvailableArchive()) {
      this.loadReportTimeBucket();
    }
  },

  methods: {
    async onCamerasSelectedFromDialog(payload) {
      const {selectedCameraKeys, searchText} = payload;
      if (selectedCameraKeys === true) {
        this.selectAllByFilter = true;
        this.selectedCameraNumbers = [];
        this.camerasFilter = searchText || null;
      } else if (Array.isArray(selectedCameraKeys)) {
        this.selectAllByFilter = false;
        this.selectedCameraNumbers = selectedCameraKeys;
        this.camerasFilter = null;
      }

      // При смене камер сбрасываем флаг загрузки
      this.isInitialDataLoaded = false;
      await this.loadReportTimeBucket();
    },
    /**
     * Рассчитывает оптимальную ширину столбцов для графика в зависимости от количества данных
     * @returns {string} - CSS значение ширины столбца
     */    getColumnWidth() {
      if (this.timeBucket === "1") { // почасовой
        const dataLength = this.chartDataForGraph.length;
        if (dataLength > 72) return "15%";   // 3+ дней
        if (dataLength > 48) return "20%";   // 2-3 дня
        if (dataLength > 24) return "25%";   // 1-2 дня
        if (dataLength > 12) return "35%";   // 12-24 часа
        return "45%";                        // до 12 часов
      }
      return "70%";
    },

    /**
     * Форматирует подписи на оси X графика
     * Для почасовых данных показывает только каждую N-ю метку для улучшения читаемости
     * @param {string} value - исходное значение метки
     * @param {number} timestamp - временная метка
     * @param {Object} opts - опции apexcharts
     * @returns {string} - отформатированная метка или пустая строка для скрытия
     */
    formatXAxisLabel(value, timestamp, opts) {
      // Проверяем, что opts существует и содержит dataPointIndex
      if (!opts || typeof opts.dataPointIndex === 'undefined') {
        return value || '';
      }
      if (this.timeBucket === "1") {
        // Для почасовых данных показываем только каждую N-ю метку
        const index = opts.dataPointIndex;
        const total = this.chartCategories ? this.chartCategories.length : 0;
        // Показываем подписи реже при большом количестве данных
        let showEvery = 1;
        if (total > 48) showEvery = 6; // каждые 6 часов
        else if (total > 24) showEvery = 3; // каждые 3 часа
        else if (total > 12) showEvery = 2; // каждые 2 часа
        if (index % showEvery !== 0) return '';
      }
      return value || '';
    },
    // Обновление настроек графика
    updateChartOptions() {
      this.chartOptions = {
        ...this.chartOptions,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: this.getColumnWidth(),
            borderRadius: 2,
          },
        },
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: this.chartCategories,
          labels: {
            ...this.chartOptions.xaxis.labels,
            formatter: this.formatXAxisLabel
          }
        },
      };
    },
    /**
     * Форматирует метки для отображения на графике в зависимости от выбранного периода агрегации
     * @param {string} start - начальная дата периода
     * @param {string} end - конечная дата периода
     * @returns {string} - отформатированная метка для отображения
     */
    formatChartLabel(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      switch(this.timeBucket) {
      case 'hour': // Почасовой
        // Используем реальные даты из данных
        return `${startDate.getDate().toString().padStart(2, '0')}.${(startDate.getMonth() + 1).toString().padStart(2, '0')} ${startDate.getHours().toString().padStart(2, '0')}:00`;
      case 'day': // По дням
        return `${startDate.getDate().toString().padStart(2, '0')}.${(startDate.getMonth() + 1).toString().padStart(2, '0')}.${startDate.getFullYear()}`;
      case 'week': // По неделям
        // eslint-disable-next-line no-case-declarations
        const weekStart = `${startDate.getDate().toString().padStart(2, '0')}.${(startDate.getMonth() + 1).toString().padStart(2, '0')}`;
        // eslint-disable-next-line no-case-declarations
        const weekEnd = `${endDate.getDate().toString().padStart(2, '0')}.${(endDate.getMonth() + 1).toString().padStart(2, '0')}`;
        return `${weekStart}-${weekEnd}`;
      case 'month': // По месяцам
        // eslint-disable-next-line no-case-declarations
        const months = [
          this.$t('janShort'), this.$t('febShort'), this.$t('marShort'), this.$t('aprShort'),
          this.$t('mayShort'), this.$t('junShort'), this.$t('julShort'), this.$t('augShort'),
          this.$t('sepShort'), this.$t('octShort'), this.$t('novShort'), this.$t('decShort')
        ];
        return `${months[startDate.getMonth()]} ${startDate.getFullYear()}`;

      default:
        return this.localDateHours(start);
      }
    },
    /**
     * Инициализирует доступные периоды агрегации для выпадающего списка
     * @returns {Object} - объект с настройками периодов агрегации
     */
    getTimePeriondsForSelect() {
      this.settingsTimeBucket = {
        "hour": this.$t('hourly'),
        "day": this.$t('daily'),
        "week": this.$t('weekly'),
        "month": this.$t('monthly')
      };
      return this.settingsTimeBucket;
    },

    resetFilters() {
      this.isLoading = true;
      this.isInitialDataLoaded = false;
      const archiveTo = new Date();
      const archiveFrom = new Date(archiveTo.getTime());
      archiveFrom.setMonth(archiveFrom.getMonth() - 1);

      this.archiveFrom = archiveFrom;
      this.archiveTo = archiveTo;
      this.searchText = "";
      this.currentPage = 1;
      this.viewType = "chart";
      this.loadReportTimeBucket();
    },
    /**
     * Основной метод загрузки данных отчета
     * Выбирает стратегию загрузки в зависимости от выбранного типа отчета
     * Обрабатывает ошибки и показывает предупреждения при большом объеме данных
     */
    async loadReportTimeBucket() {
      if (this.isLoading) return;
      if (!this.clearArchiveFrom || !this.clearArchiveTo) return;

      this.isLoading = true;
      this.isInitialDataLoaded = false;
      this.apiError = null;

      try {
        await this.loadBucketReport();
      } finally {
        this.isInitialDataLoaded = true;
        this.isLoading = false;
      }
    },
    /**
     * Загружает детальный отчет (без агрегации)
     * Загружает данные для таблицы с пагинацией и отдельно для графика
     */
    async loadDefaultReport() {
      // Таблица
      const {messages: paginatedMessages, response: paginatedResponse} =
        await this.$store.dispatch(`analytics/peopleCount/${ACTION_LOAD_PEOPLE_COUNT_REPORT}`, {
          cameraNumber: this.cameraInfo.number,
          archiveFrom: this.clearArchiveFrom,
          archiveTo: this.clearArchiveTo,
          query: this.searchText,
          page: this.currentPage,
          page_size: this.pageSize,
        });
      this.messages = paginatedMessages || [];
      this.allPages = paginatedResponse.page.all || 1;
      this.currentPage = paginatedResponse.page.current || 1;
      if (this.currentPage > this.allPages) this.currentPage = 1;
      // Данные для графика — только если нужен график
      if (this.viewType === 'chart') {
        try {
          const {messages} = await this.$store.dispatch(`analytics/peopleCount/${ACTION_LOAD_PEOPLE_COUNT_REPORT}`, {
            cameraNumber: this.cameraInfo.number,
            archiveFrom: this.clearArchiveFrom,
            archiveTo: this.clearArchiveTo,
            query: this.searchText,
            page: 1,
            page_size: 1000,
          });
          this.allDefaultReportData = messages || [];
        } catch (error) {
          console.log(error);
          this.allDefaultReportData = [];
        }
      } else {
        this.allDefaultReportData = [];
      }
    },
    /**
     * Загружает агрегированный отчет по выбранному временному интервалу
     * Используется для почасовой, ежедневной, еженедельной и ежемесячной агрегации
     */
    async loadBucketReport() {
      try {
        const cameraNumbers = this.selectedCameraNumbers.length > 0
          ? this.selectedCameraNumbers
          : [this.cameraInfo.number];
        const bucketData = await this.$store.dispatch(`analytics/peopleCount/${ACTION_LOAD_PEOPLE_COUNT_REPORT_COUNT_BUCKET}`, {
          cameraNumbers: cameraNumbers,
          archiveFrom: this.clearArchiveFrom,
          archiveTo: this.clearArchiveTo,
          timeBucket: this.timeBucket,
        });
        this.allBucketResults = (bucketData.results || []);
        this.allPages = this.bucketPagesCount;
        this.currentPage = 1;
        this.messages = {
          results: this.paginatedBucketResults,
        };
      } catch (error) {
        this.apiError = error.fields.non_field_errors[0];
        console.log(this.apiError);
        this.allBucketResults = [];
      }
    },
    /**
     * Форматирует дату в локальный формат с временем
     * @param {string} date - дата для форматирования
     * @returns {string} - отформатированная дата в формате "DD.MM.YYYY HH:mm"
     */
    localDateHours(date) {
      if (!date) {
        return "-";
      }
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, "0")}.${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}.${d.getFullYear()} ${d.getHours().toString().padStart(2, "0")}:${d
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    },
    /**
     * Скачивание архива в виде csv файла.
     *
     */
    async downloadTableAsCSVReport() {
      this.isLoading = true;
      let dateFrom = moment.tz(this.clearArchiveFrom, moment.tz.guess()).format("DD.MM.YYYY_HH.mm");
      let dateTo = moment.tz(this.clearArchiveTo, moment.tz.guess()).format("DD.MM.YYYY_HH.mm");
      let cameraTitle = this.cameraInfo.title;
      if (this.selectedCameraNumbers.length > 0) {
        cameraTitle = this.$t('camerasCount', {count: this.selectedCameraNumbers.length}) || `Cameras_${this.selectedCameraNumbers.length}`;
      }
      const filenameBuilder = `${this.$t('peopleCountReport')}_${dateFrom}-${dateTo}_${cameraTitle}.csv`;
      if (this.timeBucket === "defaultReport") {
        const apiAction = `analytics/peopleCount/${ACTION_LOAD_PEOPLE_COUNT_REPORT}`;
        const params = {
          cameraNumber: this.cameraInfo.number,
          archiveFrom: this.clearArchiveFrom,
          archiveTo: this.clearArchiveTo,
        };
        const headers = [this.$t('text'), this.$t('date')];
        const rowBuilder = (message) => {
          return `${message.text === 'in' ? this.$t('entrance') : this.$t('exit')},${this.$options.filters.localDateTime(message.date)}\r\n`;
        };
        await this.downloadTableAsCSV(apiAction, params, headers, filenameBuilder, rowBuilder);
      } else {
        let csvText;
        let headers = [this.$t('date'), this.$t('inCount'), this.$t('outCount')];
        csvText = `${headers.join(",")}\r\n`;
        this.allBucketResults.forEach((message) => {
          const formattedDate = `${this.localDateHours(message.start)} - ${this.localDateHours(
            message.end
          )}`;
          csvText += `${formattedDate},${message.in_count},${message.out_count}\r\n`;
        });
        downloadCSV(filenameBuilder, csvText);
      }

      this.isLoading = false;
    },
    openDialogAddCamera() {
      const initialSelected = this.selectedCameraNumbers.length > 0
        ? this.selectedCameraNumbers
        : [this.cameraInfo.number];
      this.$camsdals.open(
        AddCameraToReportDialog,
        {
          initialSelectedCameraNumbers: initialSelected,
        },
        {dialogTitle: this.$t('addCameras')},
        {
          closeOnBackdrop: false,
          size: "vuedal-auto-width",
          name: "js-click-outside",
          onClose: (payload) => {
            if (!payload) {
              return;
            }
            this.onCamerasSelectedFromDialog(payload);
          },
        },
      );
    },
    goBack() {
      this.$router.push({
        name: ROUTE_PACS_PEOPLE_COUNT_ANALYTICS
      });
    },
  },
};
</script>

<style lang="scss">
@use "./analytic-report.scss";

</style>
